import { render, staticRenderFns } from "./hw-h5-2.vue?vue&type=template&id=6ddefdf3"
import script from "./hw-h5-2.vue?vue&type=script&lang=js"
export * from "./hw-h5-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports